import { Vector3 } from "three";

const defaultPos = new Vector3(0, 1, 7);
const defaultLookAt = new Vector3(0, 0, 0.01);
const freePos = new Vector3(0, 0.4, 2);
const freeLookAt = new Vector3(0, 0, 0.01);
const posScreen = new Vector3(0.2, 0.8, 1.2);
const posPiano = new Vector3(-8, 2.28, -6);
const lookAtScreen = new Vector3(0.2, 0.7, 0.01);
const lookAtPiano = new Vector3(-8, 2.28, -6);

export const cameraSettings = {
  defaultPos,
  defaultLookAt,
  freePos,
  freeLookAt,
  posScreen,
  posPiano,
  lookAtScreen,
  lookAtPiano,
};
